import { Component } from '@angular/core';

/**
 * Generic screen for a guest link that cannot be opened for any reason with no screen of its own.
 *
 * It is the last resort that makes a blank page unreachable: every outcome the resolution service
 * cannot name lands here rather than nowhere (FR-002, FR-003).
 *
 * The copy speaks only about the link, never about a document. This screen is reached when the
 * application does not know whether a document exists, so naming one would disclose exactly what
 * FR-007 forbids. The next step — contact whoever sent the link — needs no platform account.
 */
@Component({
  selector: 'literax-link-error',
  templateUrl: './link-error.component.html',
  styleUrls: ['./link-error.component.scss'],
})
export class LinkErrorComponent {}
